import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=4f36ae03&scoped=true"
import script from "./CountryFlag.vue?vue&type=script&lang=js"
export * from "./CountryFlag.vue?vue&type=script&lang=js"
import style0 from "./CountryFlag.vue?vue&type=style&index=0&id=4f36ae03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36ae03",
  null
  
)

export default component.exports